import {Tour} from "@/Tour";

export default class Hotel {

    public name: string;
    public picture: string;
    public tours: Tour[];
    public extras: string[];
    public description: string;
    public city_id: string[];
    public city: string;
    public stars: number;

    constructor(name: string,picture: string) {
        this.name = name;
        this.description = "";
        this.picture = picture;
        this.tours = [];
        this.extras = [];
        this.stars = 0;
        this.city_id = [];
        this.city = "";
    }

    addTour(tour: Tour){
        this.tours.push(tour);
    }

    setCity(city_id:string,city: string){
        this.city_id = [city_id];
        this.city = city;
        return this;
    }

    appendCity(city_id:string,city: string){
        this.city_id.push(city_id);
        this.city += `, ${city}`
        return this;
    }

    setDescription(description:string){
        this.description = description;
        return this;
    }

}